import api from '@/config/axios/index';

export default {
  getAppointments() {
    return api({
      method: 'GET',
      url: '/api/v1/agendamento?sort=data&order=desc',
      data: null,
    });
  },

  getAppointmentData(appointmentId) {
    return api({
      method: 'GET',
      url: `/api/v1/agendamento/${appointmentId}`,
      data: null,
    });
  },

  cancelAppointment(appointmentId) {
    return api({
      method: 'POST',
      url: `/api/v1/agendamento/${appointmentId}/cancelar`,
      data: null,
    });
  },

  confirmAppointment(appointmentId) {
    return api({
      method: 'POST',
      url: `/api/v1/agendamento/${appointmentId}/confirmar`,
      data: null,
    });
  },

  getMedicalRecord(appointmentId) {
    return api({
      method: 'GET',
      url: `api/v1/agendamento/${appointmentId}/observacao-atendimento`
    });
  },

  getAttachments(appointmentId) {
    return api({
      method: 'GET',
      url: `api/v1/agendamento/${appointmentId}/anexo`,
    });
  },
};
